<template >
    <div class="container-fluid" v-if="department">
      <h1>{{department.name}}</h1>
      <p>{{department.description}}</p>
        <button type="button" class="my-3 btn btn-success ml-3" @click="$router.push({'name':'RootLessonAdd', params:{ schoolId: schoolId, departmentId: department.id}})">
        Хичээл нэмэх
      </button>

      <!-- DataTales Example -->
      <div class="card shadow mb-4" >
        <div class="card-header py-3">
          <h6 class="m-0 font-weight-bold text-primary">Хичээлүүд</h6>
        </div>
        <div class="card-body" v-if="pros!=null && pros.length>0">
          <div class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Нэр</th>
                  <th>индекс</th>
                  <th>Дэлгэрэнгүй</th>
                  <th>Кредит</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(p, index) in pros" v-bind:key="p.id">
                  <td>{{index+1}}</td>
                  <td>{{p.name}}</td>
                  <td>{{p.lectureCode}}</td>
                  <td>{{p.description}}</td>
                  <td>{{p.credit}}</td>
                  <td>
                    <button class="btn btn-warning btn-sm mr-2" @click="_editProgram(p)">засах</button>
                    <button class="btn btn-danger btn-sm" @click="$router.push({ name: 'RootLessonDetail', params:{ schoolId: schoolId, rootLessonId: p.id } })">хичээл үүсгэх</button>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="alert alert-warning">Одоогоор мэдээлэл ороогүй байна.</div>
      </div>


    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "DepartmentLessons",
    data() {
        return {
            department: null,
            pro:{
              'name':null,
              'hindex':null,
              'description':null,
              'teamLeader':null,
              'phone':null,
              'email':null

            },
            pros:[],

            
        };
    },
    methods: {
        
      _getQA(){

          fb.db.collection("schools/"+this.schoolId+"/departments/").doc(this.departmentId).onSnapshot(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.department=department;
          
            
          });
          fb.db.collection("schools/"+this.schoolId+"/rootlessons").where("department", "==", fb.db.collection("schools/"+this.schoolId+"/departments/").doc(this.departmentId)).orderBy("createdAt","desc").onSnapshot(querySnapshot=> {
            this.pros=[]
            querySnapshot.forEach(doc=> {
              let object=doc.data()
              object.id = doc.id
					    this.pros.push(object);
            });
            
          });

      },

      goStat(type, topic){
        this.$router.push({ name: 'TopicStat', params: { schoolId: this.schoolId, type: type.id, topicId: topic.id} })
      },
      _editProgram(pro){
        this.$router.push({'name':'RootLessonAdd', params:{ schoolId: this.schoolId, departmentId: this.department.id, lessonId: pro.id}});
      },
      _deleteProgram(pro){
          // var result = confirm("Та "+pro.name+" хөтөлбөрийг устгах уу?");
          // if (result) {
          //     fb.db.collection("schools").doc(this.schoolId).collection("departments").doc(this.departmentId).collection("programs").doc(pro.id).delete()
          // }

      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        schoolId: { 
            required: true,
        },
        departmentId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        console.log(this.schoolId);
        if(this.schoolId!=null && this.schoolId!='' && this.departmentId!=null && this.departmentId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

